import React from "react";
import {
  SecondaryResourceTitle,
  SecondaryResourceDescription,
  SecondaryResourceContainer,
  SecondaryResourceTextContainer
} from "./SecondaryResourceItem.style";
import Icon from "../../icons";
import { theme } from "../../Theme";

interface Props {
  id: string;
  title: string;
  description?: string;
  onClick: (id: string) => void;
}

const SecondaryResourceItem: React.FC<Props> = props => {
  const onClick = () => {
    props.onClick(props.id);
  };
  return (
    <SecondaryResourceContainer onClick={onClick}>
      <Icon name="video" fill={theme.color.text} width="2em" height="2em" />
      <SecondaryResourceTextContainer>
        <SecondaryResourceTitle>{props.title}</SecondaryResourceTitle>
        <SecondaryResourceDescription>
          {props.description}
        </SecondaryResourceDescription>
      </SecondaryResourceTextContainer>
    </SecondaryResourceContainer>
  );
};

export default SecondaryResourceItem;
